import IconComponent from "icons/IconComponent";

import CartIcon from "./cart.svg";

export default (CartIcon as any) as IconComponent;
